export default {"src":"/_next/static/media/person.bf595a77.svg","height":16,"width":16};